import React from 'react';

import * as AuditActions from 'audit/AuditActions';
import {EXPORT_AUDIT_LOG_DISPLAY_STRING} from 'audit/AuditConstants';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Dropdown from 'ui-library/dropdowns/Dropdown';
import {FolderItemIcon} from 'ui-library/icons/IconConstants';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';

interface SchemaSettingsExportDropdownProps {
  onExportSpreadsheetTemplate?: () => void;
  schemaId: string;
}

export default function SchemaSettingsExportDropdown(props: SchemaSettingsExportDropdownProps): JSX.Element {
  return (
    <Dropdown
      menu={
        <Menu height={Menu.HEIGHTS.MEDIUM} width={Menu.WIDTHS.MEDIUM} dropLeft={true}>
          <Option
            icon="audit-trail"
            onSelect={() => {
              AuditActions.exportAuditLogs([props.schemaId]);
            }}
            dataTestAttrs={{component: 'SchemaSettingsExportDropdown', element: 'exportAuditLogButton'}}
          >
            {EXPORT_AUDIT_LOG_DISPLAY_STRING}
          </Option>
          {props.onExportSpreadsheetTemplate && (
            <Option icon={FolderItemIcon.BasicFolderItem} onSelect={props.onExportSpreadsheetTemplate}>
              Spreadsheet template
            </Option>
          )}
        </Menu>
      }
    >
      <Button
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
        isDropdown={true}
        size={ButtonSize.SMALL}
        text="Export"
        dataTestAttrs={{component: 'SchemaSettingsExportDropdown', element: 'exportDropdownButton'}}
      />
    </Dropdown>
  );
}
